<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <div class="modal-text">
        <h3>{{ $t('more_info.latest_reviews') }}</h3>
        <div v-if="reviews && reviews.length > 0">
          <div class="quote-block" v-for="(review, key) in reviews" :key="key">
            <blockquote class="review" v-if="review.general_comments && review.reviewer">
              <q v-if="review.general_comments" v-html="review.general_comments"></q>
              <cite v-if="review.reviewer">
                <span class="name" v-if="review.reviewer.first_name">{{ review.reviewer.first_name.toLowerCase() }}</span> -
                <span class="text-success">
                  {{ review.overall_score }} 
                  {{ $t('more_info.out_of')}} 10</span>
                <time>{{ formatDate(review.sort_and_display_date, 'Do MMMM YYYY') }}</time> 
              </cite>
            </blockquote>
          </div>
        </div>
        <p v-else>{{ $t('more_info.no_reviews') }}.</p>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <right-col />
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import mixins from "@/mixins";
import { RightCol } from "@/components";
import BookingFlowService from '@/services/booking-flow/service';

export default {
  name: "ReviewsTab",
  mixins: [mixins.format],
  components: { RightCol },
  data() {
    return {
      reviews: []
    }
  },
  computed: {
    moreInfo: sync("modals/moreInfo")
  },
  created() {
    this.reviews = [];
    
    BookingFlowService.reviews(this.moreInfo.product_id, "silent").then(res => {
      this.reviews = res['data'] ? res['data'].reviews : [];
    })
  }
};
</script>